import { render } from "./DashboardLayout.vue?vue&type=template&id=5c2acbf3"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=5c2acbf3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/layout/DashboardLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c2acbf3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c2acbf3', __exports__)) {
    api.reload('5c2acbf3', __exports__)
  }
  
  module.hot.accept("./DashboardLayout.vue?vue&type=template&id=5c2acbf3", () => {
    api.rerender('5c2acbf3', render)
  })

}


export default __exports__